export default __webpack_public_path__ + "static/media/javascript-Tricks.7340515f.jpeg";